<app-filter-panel [fields]="fieldsConfig" [quickSearchFilter]="filters.caseNumber"
    quickSearchPlaceholder="Código expediente" (search)="search()"></app-filter-panel>

<!--
    <div class="flex gap-2 flex-wrap">
        <div class="input-field">
            <label for="workers">Operario </label>
            <p-dropdown [options]="workers" [(ngModel)]="filters.workerId.value" optionLabel="name" optionValue="id"
                [filter]="true" filterBy="name" appendTo="body" placeholder="Selecciona un operador" showClear
                (onChange)="search()"
                (onFilter)="loadWorkers($event)"
                (onClear)="loadWorkers(null);"></p-dropdown>
        </div>
        <div class="input-field">
            <label for="name">Responsable</label>
            <p-dropdown name="responsibleUserId" [options]="users" optionLabel="name" optionValue="id" showClear
              [filter]="true" filterBy="name" placeholder="Seleccione un responsable" appendTo="body" (onFilter)="loadUsers($event)" (onClear)="loadUsers(null);"
                [(ngModel)]="filters.processorId.value"  (onChange)="search();" />
          </div>
        <div class="input-field" style="width: 150px;">
            <label for="companyId">Compañía</label>
            <p-multiSelect [options]="companies" [(ngModel)]="filters.companyId.value"
                [ngModelOptions]="{standalone: true}" optionLabel="name" optionValue="id" placeholder="Compañía"
                showClear appendTo="body"  (onChange)="companyChanged()" (onClear)="companyChanged()"></p-multiSelect>
        </div>
        <div class="input-field" style="width: 150px;">
            <label for="contractId">Contrato</label>
            <p-multiSelect [options]="contracts" [(ngModel)]="filters.contractId.value"
                [ngModelOptions]="{standalone: true}" optionLabel="name" optionValue="id" placeholder="Contrato"
                showClear appendTo="body"  (onChange)="search()" (onClear)="search()"></p-multiSelect>
        </div>
        <span class="input-field p-input-icon-right">
            <label for="caseNumber">Codigo</label>
            <input pInputText placeholder="Código Expediente" [(ngModel)]="filters.caseNumber.value" (keydown.enter)="search()" class="w-full" />
            <i *ngIf="filters.caseNumber.value" class="pi pi-times cursor-pointer" (click)="filters.caseNumber.value = null; search()"></i>
        </span>
        <div class="input-field"  style="width: 150px;">
            <label for="createdAtFrom">Fecha creación cita desde </label>
            <p-calendar 
            id="createdAt" [firstDayOfWeek]="1" [(ngModel)]="filters.createdAtFrom.value" [showIcon]="true" [showTime]="false" [hourFormat]="'24'" dateFormat="dd/mm/yy" appendTo="body"
            (ngModelChange)="search()" [showButtonBar]="true"></p-calendar>
        </div>
        <div class="input-field"  style="width: 150px;">
            <label for="createdAtTo">Fecha creación cita hasta </label>
            <p-calendar 
            id="createdAt" [firstDayOfWeek]="1" [(ngModel)]="filters.createdAtTo.value" [showIcon]="true" [showTime]="false" [hourFormat]="'24'" dateFormat="dd/mm/yy" appendTo="body"
            (ngModelChange)="search()" [showButtonBar]="true"></p-calendar>
        </div>
        <div class="input-field"  style="width: 150px;">
            <label for="dateFrom">Fecha cita desde</label>
            <p-calendar [(ngModel)]="filters.dateFrom.value" [firstDayOfWeek]="1" [showIcon]="true" [showTime]="false"
                [hourFormat]="'24'" dateFormat="dd/mm/yy" appendTo="body" inputId="dateFrom" class="w-full"></p-calendar>
        </div>
        <div class="input-field"  style="width: 150px;">
            <label for="dateTo">Fecha cita hasta</label>
            <p-calendar [(ngModel)]="filters.dateTo.value" [firstDayOfWeek]="1" [showIcon]="true" [showTime]="false"
                [hourFormat]="'24'" dateFormat="dd/mm/yy" appendTo="body" inputId="dateTo" class="w-full"></p-calendar>
        </div>
        <span class="input-field p-input-icon-right">
            <label for="caseNumber">Código postal</label>
            <input pInputText placeholder="Código postal" [(ngModel)]="filters.zipCode.value" (keydown.enter)="search()" class="w-full" />
            <i *ngIf="filters.zipCode.value" class="pi pi-times cursor-pointer" (click)="filters.zipCode.value = null; search()"></i>
        </span>
        <span class="input-field p-input-icon-right">
            <label for="caseNumber">Ciudad</label>
            <input pInputText placeholder="Ciudad" [(ngModel)]="filters.city.value" (keydown.enter)="search()" class="w-full" />
            <i *ngIf="filters.city.value" class="pi pi-times cursor-pointer" (click)="filters.city.value = null; search()"></i>
        </span>
        <div class="input-field" style="width: 150px;">
            <label for="dateTo">Provincia</label>
            <p-dropdown placeholder="Provincias" [options]="countriesRegions" optionLabel="name" optionValue="id"
                [(ngModel)]="filters.countryRegionId.value" (onChange)="search();" showClear />
        </div>
        <div class="input-field" style="width: 150px;">
            <label for="dateTo">Estado Expediente</label>
            <p-dropdown placeholder="Estado" [options]="activeOptions" optionLabel="name" optionValue="id"
                [(ngModel)]="filters.caseNotStateFinal.value" (onChange)="search()" showClear />
        </div>
        <div class="input-field flex align-items-end">
            <button pButton label="Buscar" icon="pi pi-search" (click)="search()"></button>
            <button  pButton label="Limpiar" icon="pi pi-eraser" class="ml-2" severity="secondary" (click)="clearFilters()"></button>
        </div>
    </div>
-->

<p-table
        (onLazyLoad)="loadData($event)" [lazy]="true"
        [value]="casesServices"
        [paginator]="true"
        [rows]="25"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25, 100, 250]"
        [scrollable]="true"
        scrollHeight="flex"
        [totalRecords]="totalRecords"
        paginatorDropdownAppendTo="body"
    >
    <ng-template pTemplate="header">
    <tr>
        <!--<th >Estado cita</th>--> 
        <th pSortableColumn="worker.name">Operario<p-sortIcon field="worker.name"></p-sortIcon></th>
        <th pSortableColumn="case.caseNumber">Núm. expediente<p-sortIcon field="case.caseNumber"></p-sortIcon></th>
        <th pSortableColumn="createdAt">Fecha creación cita<p-sortIcon field="createdAt"></p-sortIcon></th>
        <th pSortableColumn="date">Fecha cita<p-sortIcon field="date"></p-sortIcon></th>
        <th pSortableColumn="createdAt">Núm. días sin confirmar<p-sortIcon field="createdAt"></p-sortIcon></th>
        <th pSortableColumn="case.address.zipCode">Código postal<p-sortIcon field="case.address.zipCode"></p-sortIcon></th>
        <th pSortableColumn="case.address.city">Ciudad<p-sortIcon field="case.address.city"></p-sortIcon></th>
        <th pSortableColumn="case.address.countryRegion.name">Provincia<p-sortIcon field="case.address.countryRegion.name"></p-sortIcon></th>
        <th pSortableColumn="capability.name">Gremio<p-sortIcon field="capability.name"></p-sortIcon></th>

    </tr>
    </ng-template>

    <ng-template pTemplate="body" let-service>
    <tr>
       <!-- <td>  LO QUITO PORQUE ESTO PUEDE LLEVAR A PONERLO EN FILTROS, LAS CAUSAS, LOS ESTADOS, ETC. AHORA SON TODAS LA QUE NO SON CANCELADAS NI RECHAZADAS NI FALLIDAS       
            <p-tag *ngIf="isOnTime(service)" severity="warn"
                value="Pendiente" />
            <p-tag *ngIf="isStarted(service)" severity="warn"
                value="En curso" />
            <p-tag *ngIf="isEnded(service)" severity="success" value="Finalizado" />
            <p-tag *ngIf="isCancelled(service)" severity="danger" value="Cancelada" 
                    pTooltip="{{service.cancelCaseServiceCauseId ? service.cancelCaseServiceCause.name:''}} - {{service.cancelCaseServiceReasonId?service.cancelCaseServiceReason.name:service.cancelCaseServiceReasonNotes}}" />
            <p-tag *ngIf="isRejected(service)" severity="danger" value="Rechazada"></p-tag>
            <p-tag *ngIf="isFailed(service)" severity="danger" value="Fallida"></p-tag>
         </td>--> 
        <td>
             <a [routerLink]="['/workers/', service.worker?.id]" target="_blank" tooltipPosition="top">{{ service.worker?.name }}</a>
        </td>
        <td>
             <a [routerLink]="['/cases/', service.case?.id]" target="_blank" tooltipPosition="top">{{ service.case?.caseNumber }}</a>
             <br>
             <small><label [ngClass]="service.case?.processor?.absence ? 'text-danger' : ''">{{service.case?.processor ? service.case?.processor?.name : 'Sin tramitador'}}</label></small>
        </td>
        <td>{{ service.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ service.date | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{getTimeAgo(service.createdAt)}}</td>
        <td>{{ service.case?.address?.zipCode }}</td>
        <td>{{ service.case?.address?.city }}</td>
        <td>{{ service.case?.address?.countryRegion?.name }}</td>
        <td>{{ service.capability?.name }}</td>

    </tr>
    </ng-template>
    </p-table>
